import { render } from "./PartnerEarningsPage.vue?vue&type=template&id=70c5afa8&scoped=true"
import script from "./PartnerEarningsPage.vue?vue&type=script&lang=js"
export * from "./PartnerEarningsPage.vue?vue&type=script&lang=js"

import "./PartnerEarningsPage.vue?vue&type=style&index=0&id=70c5afa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c5afa8"]])

export default __exports__